<button type="button" class="btn btn-outline-primary w-100" (click)="downloadCustomerList()">
  {{ 'customer.label.downloadCustomerList' | cxTranslate }}<i class="fas fa-download ml-2" aria-hidden="true"></i>
</button>
